export default (e, v) => setTimeout(() => {
    if (document.querySelector(e)) document.querySelector(e).value = v
}, 50);